import React from 'react';
import { motion } from 'framer-motion';
import SectionTitle from '../components/common/SectionTitle';
import ServiceCard from '../components/Services/ServiceCard';
import CTA from '../components/common/CTA';
import './ServicesPage.css';

const services = [
  {
    icon: '📊',
    title: 'CRM Development',
    description: 'Custom CRM solutions tailored to streamline your customer relationships and sales processes.',
    features: ['Sales automation', 'Customer segmentation', 'Reporting dashboard', 'Integration ready']
  },
  {
    icon: '🛒',
    title: 'Ecommerce Solutions',
    description: 'Scalable online stores with seamless payment processing and inventory management.',
    features: ['Multi-vendor support', 'Mobile optimized', 'SEO friendly', 'Analytics integration']
  },
  {
    icon: '📱',
    title: 'Mobile App Development',
    description: 'Cross-platform mobile applications for iOS and Android to engage your customers.',
    features: ['Native & hybrid apps', 'Offline functionality', 'Push notifications', 'App store deployment']
  },
  {
    icon: '🎨',
    title: 'UI/UX Design',
    description: 'Beautiful and intuitive interfaces that enhance user experience and engagement.',
    features: ['User research', 'Wireframing', 'Prototyping', 'Usability testing']
  },
  {
    icon: '☁️',
    title: 'Cloud Solutions',
    description: 'Scalable cloud infrastructure to support your growing business needs.',
    features: ['AWS/Azure/GCP', 'Serverless architecture', 'Database solutions', 'DevOps integration']
  },
  {
    icon: '🔧',
    title: 'Maintenance & Support',
    description: 'Ongoing support and maintenance to keep your systems running smoothly.',
    features: ['24/7 monitoring', 'Regular updates', 'Performance optimization', 'Security patches']
  }
];

const ServicesPage = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Our Services</h1>
            <p className="subtitle">
              Comprehensive solutions tailored to your business needs
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-main">
        <div className="container">
          <SectionTitle 
            title="What We Offer" 
            subtitle="Expert solutions for your business" 
          />
          
          <div className="services-grid">
            {services.map((service, index) => (
              <ServiceCard 
                key={index}
                index={index}
                service={service}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTA 
        title="Ready to transform your business?"
        description="Let's discuss how we can help you achieve your goals with our custom solutions."
        buttonText="Get Started"
        buttonLink="/contact"
      />
    </div>
  );
};

export default ServicesPage;